import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

export const RaceRegulations = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [lang, setLang] = useState("id");

  useEffect(() => {
    try {
      let stored = null;
      if (typeof window !== "undefined") {
        stored = localStorage.getItem("regulations_lang");
      }
      if (stored === "id" || stored === "en") setLang(stored);
    } catch (e) {
      // ignore
    }
  }, []);

  const setLanguage = (l) => {
    if (l !== "id" && l !== "en") return;
    setLang(l);
    try {
      if (typeof window !== "undefined") {
        localStorage.setItem("regulations_lang", l);
      }
    } catch (e) {
      // ignore
    }
  };

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const regulations = [
    {
      title: {
        id: "PERSYARATAN KEIKUTSERTAAN",
        en: "PARTICIPATION REQUIREMENTS",
      },
      content: {
        id: `
        Peserta lomba lari trail wajib:
         <ul class="list-disc pl-5 mt-2">
          <li>Memahami durasi dan karakteristik lomba serta telah mempersiapkan diri dengan baik. </li>
          <li>Memahami sifat unik dan persyaratan lomba lari trail, termasuk berlari di medan pegunungan pada malam atau pagi hari, dan telah menjalani latihan yang diperlukan.</li>
          <li>Bertanggung jawab atas diri sendiri dan memiliki kemampuan untuk mengatasi masalah yang mungkin timbul selama lomba, seperti kelelahan, masalah pencernaan, nyeri otot atau sendi, dan cedera ringan.</li>
          <li>Memahami bahwa penyelenggara tidak bertanggung jawab untuk membantu mengatasi masalah tersebut, dan keselamatan peserta bergantung pada kemampuan mereka sendiri untuk mengantisipasi dan menyesuaikan diri dengan potensi masalah.</li>
        </ul>
      `,
        en: `
        Trail race participants must:
         <ul class="list-disc pl-5 mt-2">
          <li>Understand the race duration and characteristics and have prepared themselves appropriately.</li>
          <li>Be aware of the unique nature and requirements of trail running, including running on mountainous terrain at night or in the early morning, and have completed necessary training.</li>
          <li>Be responsible for themselves and capable of handling issues that may arise during the race, such as fatigue, digestive problems, muscle or joint pain, and minor injuries.</li>
          <li>Understand that organizers are not responsible for resolving those issues, and participant safety depends on their own ability to anticipate and adapt to potential problems.</li>
        </ul>
      `,
      },
    },

    {
      title: {
        id: "KEBIJAKAN PENDAFTARAN",
        en: "REGISTRATION POLICY",
      },
      content: {
        id: `
    Dengan melakukan pendaftaran, peserta dianggap menyetujui ketentuan berikut:
    <ul class="list-disc pl-5 mt-2">
      <li>Biaya pendaftaran tidak dapat dikembalikan atau dibatalkan.</li>
      <li>Transfer BIB dapat dilakukan dalam periode waktu tertentu dengan menghubungi nomor atau email pada halaman kontak.</li>
      <li>Penggunaan BIB milik pelari lain dilarang karena alasan keselamatan dan kualifikasi, dan akan mengakibatkan diskualifikasi.</li>
    </ul>
  `,
        en: `
    By registering, participants are deemed to agree to the following terms:
    <ul class="list-disc pl-5 mt-2">
      <li>Registration fees are non-refundable and non-cancellable.</li>
      <li>BIB transfers may be allowed within a specified time frame by contacting the phone number or email on the contact page. </li>
      <li>Using another runner's BIB is prohibited for safety and qualification reasons and will result in disqualification.</li>
    </ul>
  `,
      },
    },

    {
      title: {
        id: "MANDATORY GEARS",
        en: "MANDATORY GEAR",
      },
      content: {
        id: `
    Peserta wajib membawa Mandatory Gears (Peralatan Wajib) sesuai kategori lomba (lihat pada halaman detail kategori). 
    <ul class="list-disc pl-5 mt-2">
      <li>Tidak membawa peralatan wajib akan dikenakan penalti. </li>
      <li>Marshal berhak memeriksa isi vest/belt peserta secara acak, dan peserta wajib mematuhi pemeriksaan tersebut.</li>
      <li>Marshal berhak mendiskualifikasi peserta yang tidak mematuhi pemeriksaan. </li>
    </ul>
  `,
        en: `
    Participants are required to carry the Mandatory Gear according to their race category (see category detail page).
    <ul class="list-disc pl-5 mt-2">
      <li>Failure to carry mandatory gear will result in penalties.</li>
      <li>Marshals have the right to randomly check the contents of participants' vests/belts, and participants must comply with such inspections.</li>
      <li>Marshals may disqualify participants who do not comply with inspections.</li>
    </ul>
  `,
      },
    },

    {
      title: {
        id: "WATER STATIONS",
        en: "WATER STATIONS",
      },
      content: {
        id: `
    Makanan dan minuman disediakan di tiga lokasi berbeda sepanjang rute, yaitu WS Kandang Badak, WS Surken, dan WS Putri.  <br/><br/>
    Water stations menyediakan:
    <ul class="list-disc pl-5 mt-2">
      <li>Air mineral, minuman berkarbonasi, isotonik, serta buah-buahan. </li>
      <li>Peserta wajib membawa foldable cup untuk menghindari penggunaan plastik sekali pakai.</li>
    </ul>
  `,
        en: `
    Food and drinks are provided at three different locations along the route: WS Kandang Badak, WS Surken, and WS Putri. <br/><br/>
    The water stations provide:
    <ul class="list-disc pl-5 mt-2">
      <li>Bottled water, carbonated drinks, isotonic drinks, and fruits.</li>
      <li>Participants are required to bring a foldable cup to avoid single-use plastics.</li>
    </ul>
  `,
      },
    },

    {
      title: {
        id: "BANTUAN MEDIS",
        en: "MEDICAL ASSISTANCE",
      },
      content: {
        id: `
    Penyelenggara menyediakan tim medis di beberapa lokasi untuk memberikan pertolongan pertama apabila diperlukan.  Meskipun demikian, setiap peserta tetap memiliki tanggung jawab penuh atas kondisi dan keselamatan dirinya sendiri selama mengikuti lomba.  <br/><br/>
    Tim medis berwenang untuk:
  <ul class="list-disc pl-5 mt-2">
      <li>Menghentikan peserta apabila dinilai tidak layak untuk melanjutkan lomba. </li>
      <li>Mengevakuasi peserta yang berada dalam situasi berbahaya. </li>
      <li>Merujuk peserta ke fasilitas kesehatan apabila diperlukan.</li>
    </ul>
  `,
        en: `
    The organizer provides medical teams at several locations to give first aid if necessary. Nevertheless, each participant remains fully responsible for their own condition and safety during the race. <br/><br/>
    The medical team has the authority to:
  <ul class="list-disc pl-5 mt-2">
      <li>Stop a participant if they are deemed unfit to continue the race.</li>
      <li>Evacuate participants who are in dangerous situations.</li>
      <li>Refer participants to healthcare facilities if necessary.</li>
    </ul>
  `,
      },
    },
    {
      title: {
        id: "SURAT SEHAT",
        en: "MEDICAL CERTIFICATE",
      },
      content: {
        id: `
    Peserta wajib membawa surat sehat yang menyatakan bahwa mereka secara fisik layak untuk mengikuti lomba.  Surat sehat ini harus diterbitkan maksimal 7-hari sebelum lomba dan dapat diperoleh dari klinik, rumah sakit, atau dokter.  Tanpa surat sehat, peserta tidak akan menerima nomor lomba (BIB). 
  `,
        en: `
    Participants are required to bring a medical certificate stating they are physically fit to participate in the race. This certificate must be issued at most 7 days before the race and can be obtained from a clinic, hospital, or doctor. Without a medical certificate, participants will not receive a race number (BIB).
  `,
      },
    },

    {
      title: {
        id: "PENANDA JALAN",
        en: "ROUTE MARKING",
      },
      content: {
        id: `
        Rute ditandai dengan pita, signage, dan tanda lainnya, dengan bagian reflektif untuk visibilitas malam. Petugas lomba akan ditempatkan di sepanjang rute dan persimpangan.  Ikuti petunjuk petugas.  Tanda dipasang sebelum lomba dan dihapus setelahnya.  Untuk pertimbangan lingkungan, cat tidak digunakan sebagai penanda. 
      `,
        en: `
        The route is marked with ribbons, signage, and other markers, including reflective elements for night visibility. Race officials will be positioned along the route and at intersections. Follow officials' instructions. Markers are installed before the race and removed afterwards. Paint is not used as a marker for environmental considerations.
      `,
      },
    },
    {
      title: {
        id: "BERHENTI DARI LOMBA",
        en: "WITHDRAWING FROM THE RACE",
      },
      content: {
        id: `
    Dalam situasi peserta memutuskan atau terpaksa berhenti dari lomba, berlaku ketentuan berikut:
    <ul class="list-disc pl-5 mt-2">
      <li>Peserta yang berhenti disarankan segera melapor ke petugas. </li>
      <li>Peserta yang berhenti tidak diperkenankan melanjutkan lomba.</li>
    </ul>
  `,
        en: `
    If a participant decides or is forced to withdraw from the race, the following applies:
    <ul class="list-disc pl-5 mt-2">
      <li>Participants who withdraw are advised to immediately report to race officials.</li>
      <li>Participants who withdraw are not allowed to continue the race.</li>
    </ul>
  `,
      },
    },

    {
      title: {
        id: "TINDAKAN DILARANG",
        en: "PROHIBITED ACTIONS",
      },
      content: {
        id: `
    Peserta dilarang melakukan tindakan berikut selama perlombaan:
    <ul class="list-disc pl-5 mt-2">
      <li>Memotong jalur. </li>
      <li>Membuang sampah. </li>
      <li>Tidak membawa peralatan wajib. </li>
      <li>Mendampingi pelari tanpa registrasi.</li>
      <li>Melakukan kecurangan (misalnya menggunakan transportasi lain).</li>
      <li>Melanggar instruksi petugas.</li>
      <li>Menggunakan doping.</li>
    </ul><br/>
    Pelanggaran atas ketentuan di atas dapat dikenakan sanksi berupa penalti atau diskualifikasi, sesuai keputusan panitia.
  `,
        en: `
    Participants are prohibited from doing the following during the race:
    <ul class="list-disc pl-5 mt-2">
      <li>Cutting the course.</li>
      <li>Littering.</li>
      <li>Failing to carry mandatory equipment.</li>
      <li>Accompanying a runner without registration.</li>
      <li>Cheating (e.g., using other transportation). </li>
      <li>Ignoring officials' instructions.</li>
      <li>Using doping.</li>
    </ul><br/>
    Violations of the above may result in penalties or disqualification, at the committee's discretion.
  `,
      },
    },

    {
      title: {
        id: "TANGGUNG JAWAB DAN PENGHENTIAN LOMBA",
        en: "RESPONSIBILITY AND RACE SUSPENSION",
      },
      content: {
        id: `
    Setiap peserta bertanggung jawab atas keselamatan diri dan segala risiko yang mungkin timbul selama lomba. Penyelenggara tidak bertanggung jawab atas kerusakan properti pribadi yang terjadi di luar kendali.  <br/><br/>
    Lomba dapat dihentikan sementara atau dipersingkat apabila terjadi kondisi darurat, termasuk namun tidak terbatas pada:
  <ul class="list-disc pl-5 mt-2">
      <li>Peringatan cuaca ekstrem.</li>
      <li>Bencana alam (mengacu pada informasi resmi BMKG).</li>
    </ul>
  `,
        en: `
    Each participant is responsible for their own safety and for any risks that may arise during the race. The organizer is not responsible for damage to personal property that occurs beyond their control.  <br/><br/>
    The race may be temporarily suspended or shortened in case of emergencies, including but not limited to:
  <ul class="list-disc pl-5 mt-2">
      <li>Extreme weather warnings.</li>
      <li>Natural disasters (referring to official BMKG information). </li>
    </ul>
  `,
      },
    },

    {
      title: {
        id: "HAK MEDIA DAN PUBLIKASI",
        en: "MEDIA AND PUBLICATION RIGHTS",
      },
      content: {
        id: `
        Dengan berpartisipasi, peserta setuju bahwa:
      <ul class="list-disc pl-5 mt-2">
          <li>Penyelenggara berhak mengambil dan menggunakan foto, video, hasil lomba, dan konten media lainnya selama dan setelah acara untuk keperluan promosi, pemasaran, dan editorial di berbagai platform, termasuk surat kabar, televisi, majalah, situs web, dan media sosial.</li>
          <li>Peserta memberikan lisensi bebas royalti, worldwide, dan abadi kepada penyelenggara untuk menggunakan gambar, nama, dan hasil lomba tanpa kompensasi atau pemberitahuan tambahan.</li>
          <li>Penyelenggara memiliki semua hak atas media resmi acara dan dapat mendistribusikan konten sesuai kebijakan mereka.</li>
          <li>Peserta yang tidak ingin ditampilkan dalam media terkait acara harus mengajukan permintaan tertulis kepada penyelenggara sebelum hari lomba.</li>
        </ul>
      `,
        en: `
        By participating, participants agree that:
      <ul class="list-disc pl-5 mt-2">
          <li>The organizer has the right to take and use photos, videos, race results, and other media content during and after the event for promotion, marketing, and editorial purposes across various platforms, including newspapers, television, magazines, websites, and social media. </li>
          <li>Participants grant the organizer a royalty-free, worldwide, perpetual license to use images, names, and race results without compensation or additional notice.</li>
          <li>The organizer owns all official event media rights and may distribute content according to their policies.</li>
          <li>Participants who do not wish to be featured in event-related media must submit a written request to the organizer before race day.</li>
        </ul>
      `,
      },
    },
    {
      title: {
        id: "KELUHAN DAN PROTES",
        en: "COMPLAINTS AND PROTESTS",
      },
      content: {
        id: `
        Semua keberatan terhadap keputusan panitia atau rute lomba harus disampaikan secara tertulis, disertai dengan deposit Rp1.000.000 (tidak dapat dikembalikan jika keberatan dianggap tidak valid), dalam waktu dua jam setelah peserta tiba di garis finish. Hakim lomba, yang terdiri dari:
      <ul class="list-disc pl-5 mt-2">
          <li>Juri Lari. </li>
          <li>Race Director.</li>
          <li>Perwakilan ALTI.</li>
          <li>Pihak kompeten yang dipilih oleh direktur lomba.</li>
        </ul> <br/>
        Hakim lomba berwenang membuat keputusan final yang tidak dapat diganggu gugat. 
      `,
        en: `
        All objections to the committee's decisions or the race route must be submitted in writing, accompanied by a deposit of IDR 1,000,000 (non-refundable if the objection is considered invalid), within two hours after the participant crosses the finish line. The race jury, which consists of:
      <ul class="list-disc pl-5 mt-2">
          <li>Running Judges.</li>
          <li>Race Director.</li>
          <li>ALTI Representative.</li>
          <li>Other competent parties appointed by the race director.</li>
        </ul> <br/>
        The race jury has the authority to make final and binding decisions. 
      `,
      },
    },
  ];

  return (
    <section
      id="race-regulations"
      className="w-full min-h-screen py-20 text-center text-lime-600 flex flex-col justify-center relative bg-white"
    >
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Language toggle - aligned right with content width */}
          <div className="flex justify-end mb-8">
            <div
              className="inline-flex rounded-md shadow-sm"
              role="group"
              aria-label="Language switcher"
            >
              <button
                onClick={() => setLanguage("id")}
                aria-pressed={lang === "id"}
                className={`px-4 py-1 text-sm font-medium transition ${
                  lang === "id"
                    ? "bg-lime-600 text-white rounded-l-md"
                    : "bg-white text-lime-600 border border-lime-200 rounded-l-md hover:bg-lime-50"
                }`}
              >
                Bahasa (ID)
              </button>
              <button
                onClick={() => setLanguage("en")}
                aria-pressed={lang === "en"}
                className={`px-4 py-1 text-sm font-medium transition ${
                  lang === "en"
                    ? "bg-lime-600 text-white rounded-r-md"
                    : "bg-white text-lime-600 border border-lime-200 rounded-r-md hover:bg-lime-50"
                }`}
              >
                English
              </button>
            </div>
          </div>

          <div className="space-y-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <div className="join join-vertical">
                {regulations.map((reg, index) => (
                  <div
                    key={index}
                    className="collapse collapse-arrow join-item group"
                  >
                    <input
                      type="radio"
                      name="race-regulations-accordion"
                      checked={activeIndex === index}
                      onChange={() => toggleAccordion(index)}
                    />
                    <div
                      className={`collapse-title text-left text-base font-medium uppercase transition-colors duration-200
          ${activeIndex === index ? "text-lime-600" : "text-gray-600"} 
          group-hover:text-lime-600`}
                    >
                      {lang === "id" ? reg.title.id : reg.title.en}
                    </div>
                    <div
                      className="collapse-content text-left text-base text-gray-600"
                      dangerouslySetInnerHTML={{
                        __html: lang === "id" ? reg.content.id : reg.content.en,
                      }}
                    />
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RaceRegulations;